<modal>
  <span header class="uppercase" [ngClass]="{'text-success': mode == 'income', 'text-danger': mode == 'expense'}">{{'Tạo phiếu ' + (mode == 'income' ? 'thu từ' : 'chi tới') | lang}} {{partner.Name}}</span>
  <p>{{'Ngày'}}</p>
  <calendar [selected]="time" (change)="time=$event"></calendar>
  <p>{{'Số tiền' | lang}} (đ)</p>
  <number-input class="text-center" [ngClass]="{'text-success': mode == 'income', 'text-danger': mode == 'expense'}" [value]="payment.SendAmount" (change)="update($event.target)"></number-input>
  <p>{{'Lý do ' + (mode == 'income' ? 'thu' : 'chi') | lang}}</p>
  <textarea [(ngModel)]="payment.Notes"></textarea>

  <div class="flex">
    <button class="text-white bg-success" (click)="save()"><i class="fa fa-save"></i><span>{{'Lưu' | lang}}</span></button>
    <button class="text-white bg-warning" (click)="close()"><i class="fa fa-arrow-left"></i><span>{{'Quay lại' | lang}}</span></button>
  </div>
</modal>
